module.exports = __webpack_public_path__ + "img/Esporodóquios e Conídios 2.dcbf3e08.webp";